// <referral-lifecycle data-src="…" …> — draws the referral lifecycle chart, fetching
// both its data (data-src) and its heavy d3 drawing code on demand. Because it's a
// custom element it upgrades whenever it's inserted into the DOM — including content
// injected via innerHTML (e.g. a help page loaded into the paginating modal) — so it
// no longer depends on a page-load scan that misses dynamically added charts.
class ReferralLifecycle extends HTMLElement {
  connectedCallback() {
    if (this._started) return
    this._started = true

    // Load the d3 chart bundle and render — once, the first time the element scrolls
    // into view (or immediately where IntersectionObserver isn't available), so the
    // chart code and the server-side derivation aren't paid on pages that don't show it.
    const start = () => import("./chart").then((chart) => chart.load(this))

    if (typeof IntersectionObserver === "undefined") {
      start()
      return
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          observer.disconnect()
          start()
        }
      })
    }, { rootMargin: "200px" })
    observer.observe(this)
  }
}

if (!customElements.get("referral-lifecycle")) {
  customElements.define("referral-lifecycle", ReferralLifecycle)
}
